import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiError } from '@api/models';
import { TranslateService } from '@ngx-translate/core';
import { ErrorModalComponent } from '@shared/components/error-modal/error-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { throwError } from 'rxjs';
import { ERROR_CODES, ErrorCode } from 'src/app/mosaic/constants/error-codes.constants';
import { IMosaicError, InfoModalConfig } from 'src/app/mosaic/models';
import { MosaicModalService } from 'src/app/mosaic/services/mosaic-modal.service';

import { LoadingService } from '../loading/loading.service';
import { ROUTING_MENU, RouterMenuTypes } from './../../config/routing-menu';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private modalRef: BsModalRef | null = null;

  constructor(
    private modalService: BsModalService,
    private router: Router,
    private mosaicModalService: MosaicModalService,
    private translateService: TranslateService,
    private loadingService: LoadingService,

    @Inject(ROUTING_MENU) private routingMenu: RouterMenuTypes,
  ) {}

  showError(error: ApiError, onHide?: () => void) {
    const initialState = { error };
    this.modalRef = this.modalService.show(ErrorModalComponent, {
      initialState,
      animated: false,
      ariaLabelledBy: 'modal-error-title',
    });
    const component = this.modalRef.content as ErrorModalComponent;

    const subs = component.hide.subscribe(() => {
      // Additional callback when close modal
      if (onHide) {
        onHide();
      }

      subs.unsubscribe();
    });

    return this.modalRef;
  }

  hide() {
    this.modalRef?.hide();
  }

  redirectErrorPage(e) {
    this.router.navigate([`/${this.routingMenu.PRIVATE_AREA}/${this.routingMenu.ERROR}`]);
    return throwError(e);
  }

  async handleErrorCode(error: ErrorCode): Promise<void> {
    //console.log('* / handleErrorCode / error:', error);
    // Oculta el indicador de carga antes de mostrar cualquier modal de error.
    // Esto evita que el loading quede activo cuando se muestra el modal genérico.
    this.loadingService.hide();

    // Use unified method that resolves the modal config from the MAP or fallbacks.
    if (error === ERROR_CODES.VALIDATION_FAILED) {
      await this.mosaicModalService.showErrorByCode(error);
      return;
    }

    await this.mosaicModalService.showErrorByCode(error);
  }

  async handleExceptionError(error: IMosaicError): Promise<void> {
    //console.log('[ErrorHandlingService] Exception error:', error);
    this.loadingService.hide();
    const state = this.generateDefaultErrorState(error);
    await this.mosaicModalService.showErrorModal(state);
  }

  private generateDefaultErrorState(error: IMosaicError): InfoModalConfig {
    return {
      head: error.errorCode || 'Error.title',
      description: error.description || error.message || 'Error.generic',
      type: 'info',
    };
  }
}
